// ContactUsForm.js
import React, { useState } from "react";
import DatePicker from "react-datepicker";
import PhoneInput from "react-phone-input-2";
import "react-datepicker/dist/react-datepicker.css";
import "react-phone-input-2/lib/style.css";
import "../styles/components/ContactUsForm.css"; // Import the CSS file

const ContactUsForm = () => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [contactNumber, setContactNumber] = useState("");
  const [subject, setSubject] = useState();
  const [message, setMessage] = useState("");

  const [region, setRegion] = useState("");

  // State to track whether required fields are filled
  const [requiredFieldsFilled, setRequiredFieldsFilled] = useState(true);

  const handlePhoneChange = (value, country) => {
    setContactNumber(value);
  };

  const generateMailtoLink = () => {
    const body = encodeURIComponent(
      `Name: ${name}\nEmail: ${email}\nContact Number: +${contactNumber}\nRegion: ${region}\nSubject: ${subject}\nMessage: ${message}`
    );
    return `mailto:info@Ezclinicstaffing.org?subject=${subject}&body=${body}`;
  };

  const handleMailtoClick = () => {
    // Check if all required fields are filled
    if (!name || !email || !contactNumber || !region || !message) {
      // Set state to indicate that required fields are not filled
      setRequiredFieldsFilled(false);
      return;
    }

    const mailtoLink = generateMailtoLink();
    window.location.href = mailtoLink;
  };

  return (
    <div
      style={{
        backgroundColor: "#3498db",
        color: "#fff",
        padding: "1.5rem",
        borderRadius: ".5em",
      }}
    >
      <div>
        <h5 className="card-title" style={{ marginBottom: "1rem" }}>
          Contact Us{" "}
        </h5>
        <form>
          <div className="form-group">
            <label htmlFor="name">Name:</label>
            <input
              type="text"
              className="form-control"
              id="name"
              placeholder="Enter your name"
              value={name}
              onChange={(e) => setName(e.target.value)}
              required
            />
            {/* Display error message if required field is not filled */}
            {!name && !requiredFieldsFilled && (
              <p style={{ color: "red", marginBottom: "0", fontSize: ".9em" }}>
                *this field is required
              </p>
            )}
            <div style={{ marginBottom: ".6em" }}></div>
          </div>

          <div className="form-group">
            <label htmlFor="email">Email:</label>
            <input
              type="email"
              className="form-control"
              id="email"
              placeholder="Enter your email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
            {/* Display error message if required field is not filled */}
            {!email && !requiredFieldsFilled && (
              <p style={{ color: "red", marginBottom: "0", fontSize: ".9em" }}>
                *this field is required
              </p>
            )}
            <div style={{ marginBottom: ".6em" }}></div>
          </div>

          <div className="form-group">
            <label htmlFor="contactNumber">Contact Number:</label>
            <PhoneInput
              country={"us"} // Set the default country
              value={contactNumber}
              onChange={handlePhoneChange}
              inputProps={{
                name: "contactNumber",
                required: true,
              }}
            />
            {/* Display error message if required field is not filled */}
            {!contactNumber && !requiredFieldsFilled && (
              <p style={{ color: "red", marginBottom: "0", fontSize: ".9em" }}>
                *this field is required
              </p>
            )}
            <div style={{ marginBottom: ".6em" }}></div>
          </div>

          <div className="form-group">
            <label htmlFor="region">Region:</label>
            <input
              type="text"
              className="form-control"
              id="region"
              placeholder="Enter your region"
              value={region}
              onChange={(e) => setRegion(e.target.value)}
              required
            />
            {/* Display error message if required field is not filled */}
            {!region && !requiredFieldsFilled && (
              <p style={{ color: "red", marginBottom: "0", fontSize: ".9em" }}>
                *this field is required
              </p>
            )}
            <div style={{ marginBottom: ".6em" }}></div>
          </div>

          <div className="form-group">
            <label htmlFor="subject">Subject:</label>
            <input
              type="text"
              className="form-control"
              id="subject"
              placeholder="Enter your subject for contacting Ezclinicstaffing"
              value={subject}
              onChange={(e) => setSubject(e.target.value)}
              required
            />
            {/* Display error message if required field is not filled */}
            {!subject && !requiredFieldsFilled && (
              <p style={{ color: "red", marginBottom: "0", fontSize: ".9em" }}>
                *this field is required
              </p>
            )}
            <div style={{ marginBottom: ".6em" }}></div>
          </div>

          <div className="form-group">
            <label htmlFor="message">Message:</label>
            <textarea
              className="form-control"
              id="message"
              placeholder="Enter your message"
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              rows={6}
            ></textarea>
            {!message && !requiredFieldsFilled && (
              <p style={{ color: "red", marginBottom: "0", fontSize: ".9em" }}>
                *this field is required
              </p>
            )}
          </div>

          <button
            type="button"
            className="btn btn-light"
            style={{ marginTop: "1em" }}
            onClick={handleMailtoClick}
          >
            Contact Us
          </button>
        </form>
      </div>
    </div>
  );
};

export default ContactUsForm;
